import { ROUTES } from '@/constants/application-urls';
import HeaderDictionary from '@/types/dictionaries/Header';

const breadcrumbs: {
	id: string;
	url: string;
	breadcrumbUrl?: string;
	getTitle: (dict: HeaderDictionary) => string;
}[] = [
	{
		id: 'home',
		url: '',
		breadcrumbUrl: ROUTES.HOME,
		getTitle: (dict: HeaderDictionary) => dict.home,
	},
	{
		id: 'categories',
		url: ROUTES.CATEGORIES,
		getTitle: (dict: HeaderDictionary) => dict.products,
	},
	{
		id: 'industries',
		url: ROUTES.INDUSTRIES,
		getTitle: (dict: HeaderDictionary) => dict.industries,
	},
	{
		id: 'cart',
		url: ROUTES.CART,
		getTitle: (dict: HeaderDictionary) => dict.shoppingCart,
	},
	{
		id: 'checkout',
		url: ROUTES.CHECKOUT,
		getTitle: (dict: HeaderDictionary) => dict.checkout,
	},
	{
		id: 'products',
		url: ROUTES.PRODUCTS,
		getTitle: (dict: HeaderDictionary) => dict.products,
	},
	{
		id: 'orders',
		url: ROUTES.ORDERS,
		getTitle: (dict: HeaderDictionary) => dict.orders,
	},
	{
		id: 'invoices',
		url: ROUTES.INVOICES,
		getTitle: (dict: HeaderDictionary) => dict.invoices,
	},
	{
		id: 'addresses',
		url: ROUTES.ADDRESSES,
		getTitle: (dict: HeaderDictionary) => dict.addresses,
	},
	{
		id: 'quick-order',
		url: ROUTES.QUICK_ORDER,
		getTitle: (dict: HeaderDictionary) => dict.quickOrder,
	},
];

export const getBreadcrumb = (
	pagePath: string,
	dict: HeaderDictionary,
): { href: string; title: string; id: string } | undefined => {
	const breadcrumb = breadcrumbs.find((b) => b.url === pagePath);
	return breadcrumb
		? { title: breadcrumb.getTitle(dict), href: breadcrumb.breadcrumbUrl ?? breadcrumb.url, id: breadcrumb.id }
		: undefined;
};
